import React from "react";
import { Box, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useTranslation } from "react-i18next";
import { useSound } from "../../../../../../context/juno/SoundContext";
import { ColumnBox } from "../../../../../../utils/styledBox";

const NegativePromptControl: React.FC = () => {
  const { t } = useTranslation();
  const { negativePrompt, setNegativePrompt } = useSound();

  return (
    <ColumnBox>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
        <Typography variant="body2">{t("juno.sound.params.negativePrompt")}</Typography>
        <Tooltip title={t("juno.sound.params.negativePromptHelp")} placement="top">
          <IconButton size="small">
            <InfoIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <TextField
        value={negativePrompt}
        onChange={(e) => setNegativePrompt(e.target.value)}
        multiline
        rows={2}
        placeholder={t("juno.sound.params.negativePromptPlaceholder")}
        variant="outlined"
        fullWidth
      />
    </ColumnBox>
  );
};

export default NegativePromptControl;
